export class AgrupadorKit {
            public cantidad: number;
            public grpMaterial: string;
            constructor() { }
    }
